export abstract class BrowserStorage {
  abstract getItem<T = string>(key: string): T | undefined;
  abstract removeItem(key: string): void;
  abstract setItem<T = any>(key: string, item: T): void;
  public cookieConsentRequired = true;
}
